import Nullstack from 'nullstack';
export default function IconSubtask({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-subtask",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "9",
    x2: "12",
    y2: "9"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "5",
    x2: "8",
    y2: "5"
  }), "   ", Nullstack.element("path", {
    d: "M6 5v11a1 1 0 0 0 1 1h5"
  }), "   ", Nullstack.element("rect", {
    x: "12",
    y: "7",
    width: "8",
    height: "4",
    rx: "1"
  }), "   ", Nullstack.element("rect", {
    x: "12",
    y: "15",
    width: "8",
    height: "4",
    rx: "1"
  }), " ");
}